import { render, staticRenderFns } from "./Location2DisplayComponent.vue?vue&type=template&id=952ca2ce&"
import script from "./Location2DisplayComponent.vue?vue&type=script&lang=ts&"
export * from "./Location2DisplayComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports